<div mat-dialog-title class="title-container">
  <span class="title">{{ data.title }}</span>
  <button mat-icon-button mat-dialog-close class="material-icons floatRight">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content class="dialog-container">
  <div class="story">
    <div class="label" i18n="@@CancelOrderDialogLabel">Cancel Date</div>
    <mat-form-field appearance="outline">
      <input
        matInput
        [matDatepicker]="$any(picker)"
        [(ngModel)]="selectedDate"
        [min]="minDate"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="picker"
        role="button"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="line-top">
  <button
    class="cdx-but-md"
    color="primary"
    mat-stroked-button
    mat-dialog-close
    i18n="@@CancelOrderDialogBackBtn"
  >
    Back
  </button>
  <button
    mat-flat-button
    color="primary"
    class="marginBottom"
    (click)="cancelOrder()"
  >
    @if (data.selectedCount > 1) {
    <ng-container i18n="@@CancelOrderDialogCancelOrdersBtn"
      >Cancel Orders</ng-container
    >
    } @else {
    <ng-container i18n="@@CancelOrderDialogCancelOrderBtn"
      >Cancel Order</ng-container
    >
    }
  </button>
</mat-dialog-actions>
